import { render } from "./LeadershipCards.vue?vue&type=template&id=05f55eba&scoped=true"
import script from "./LeadershipCards.vue?vue&type=script&lang=js"
export * from "./LeadershipCards.vue?vue&type=script&lang=js"

import "./LeadershipCards.vue?vue&type=style&index=0&id=05f55eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f55eba"]])

export default __exports__